(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glaverra-collection-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gv-collection-gallery'))customElements.define('gv-collection-gallery',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.gv-gallery__track');this.controls=this.querySelector('.gv-controls');this.buttons=[...this.querySelectorAll('[data-direction]')];this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<2;this.querySelector('.gv-swipe').hidden=max<2;this.buttons[0].disabled=this.track.scrollLeft<2;this.buttons[1].disabled=this.track.scrollLeft>=max-2;};this.buttons.forEach(button=>button.addEventListener('click',()=>this.track.scrollBy({left:Number(button.dataset.direction)*(this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();}
 disconnectedCallback(){this.observer?.disconnect();this.track?.removeEventListener('scroll',this.update);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glaverra-collection-groups"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=root=>{if(root.dataset.enhanced)return;root.dataset.enhanced='true';const motion=matchMedia('(prefers-reduced-motion: reduce)'),pointer=matchMedia('(hover: hover) and (pointer: fine)');
 root.querySelectorAll('.gv-collection').forEach(card=>{let frame=0;const reset=()=>{cancelAnimationFrame(frame);card.style.removeProperty('--gv-rx');card.style.removeProperty('--gv-ry')};card.addEventListener('pointermove',e=>{if(motion.matches||!pointer.matches||e.pointerType==='touch')return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const r=card.getBoundingClientRect();card.style.setProperty('--gv-rx',((.5-(e.clientY-r.top)/r.height)*3).toFixed(2)+'deg');card.style.setProperty('--gv-ry',(((e.clientX-r.left)/r.width-.5)*3).toFixed(2)+'deg')})});card.addEventListener('pointerleave',reset);card.addEventListener('blur',reset);motion.addEventListener('change',reset)});
 if('IntersectionObserver' in window){const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){if(!motion.matches)e.target.animate([{opacity:.65,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:380,easing:'ease-out'});io.unobserve(e.target)}}),{threshold:.08});root.querySelectorAll('.gv-gallery').forEach(el=>io.observe(el))}
 };document.querySelectorAll('.gv-compact').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.gv-compact').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glaverra-custom-tiles"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.querySelector('.gv-custom-tiles');if(!root)return;const motion=matchMedia('(prefers-reduced-motion: reduce)'),fine=matchMedia('(hover:hover) and (pointer:fine)');root.querySelectorAll('.gv-custom-card').forEach(card=>{let frame;const reset=()=>{cancelAnimationFrame(frame);card.style.removeProperty('--rx');card.style.removeProperty('--ry')};card.addEventListener('pointermove',e=>{if(motion.matches||!fine.matches||e.pointerType==='touch')return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const r=card.getBoundingClientRect();card.style.setProperty('--rx',((.5-(e.clientY-r.top)/r.height)*4)+'deg');card.style.setProperty('--ry',(((e.clientX-r.left)/r.width-.5)*4)+'deg')})});card.addEventListener('pointerleave',reset);motion.addEventListener('change',reset)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glaverra-quality-compare')) {
    customElements.define('glaverra-quality-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const range = this.querySelector('input');
        const update = () => this.style.setProperty('--gq-position', `${range.value}%`);
        range.addEventListener('input', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
